import { LOGGER_ACTIONS } from 'constants/actions';


export const storeUserId = userId => ({ type: LOGGER_ACTIONS.STORE_USER_ID, userId });

export const storeVisitId = (visitId, refreshTime = true) => ({ refreshTime, type: LOGGER_ACTIONS.STORE_VISIT_ID, visitId });
